// extracted by mini-css-extract-plugin
export default {"skeletonMenuBar":"topMenu-module__skeletonMenuBar__rXMdc","hotelMenuBarContainer":"topMenu-module__hotelMenuBarContainer__g7lqd","hotelMenuBar":"topMenu-module__hotelMenuBar__4l12E"};